import {http} from '../http'
import * as coreAuth from '../../coreApi/auth'

import {APIResponse} from '../types'
import {handleError} from '../handleError'

type ResolvedReturn = APIResponse<null>

export interface Logout {
  (): Promise<ResolvedReturn>
}

const ERROR_PATH = 'api.auth.logout()'
const GENERIC_ERROR = 'general'

export const logout: Logout = async () => {
  let resolvedReturn: ResolvedReturn

  try {
    const response = await coreAuth.logout(http)

    if (response.data.Status === 'Success') {
      resolvedReturn = {
        result: 'success',
        data: null,
      }
    } else {
      throw new Error('Unable to logout')
    }
  } catch (e) {
    resolvedReturn = handleError(ERROR_PATH, GENERIC_ERROR, e)
  }
  return Promise.resolve(resolvedReturn)
}
